<template>
  <div v-if="!isLoading">
<!--    <div class="downAppImg position-fixed cursor-pointer bottom-5" v-if="isShowApp">-->
<!--      <van-button @click="goDownPage" round type="info">APP内打开</van-button>-->
<!--    </div>-->
    <subject-advance v-if="!canLearn && this.projectObj.id"></subject-advance>
    <subject-home v-if="canLearn && this.projectObj.id"></subject-home>
    <no-course-page v-else-if="(!projectObj || (projectObj && !projectObj.id))"
                    tipTxt="当前项目不存在或尚未发布"></no-course-page>
  </div>
</template>


<script>
  import SubjectAdvance from '@/page/subject/subjectAdvance'
  import SubjectHome from '@/page/subject-home/subjectHome'
  import NoCoursePage from '@/page/course/noCoursePage'
  import Vue from "vue";
  import {Icon} from "vant";
  Vue.use(Icon);
  export default {
    name: "indexProject",
    data() {
      return {
        canLearn: false,
        projectObj: {},
        projectId: '',
        isLoading : false,
        isShowApp : false,
      }
    },
    components: {
      SubjectAdvance,
      SubjectHome,
      NoCoursePage
    },
    mounted() {
      this.projectId = this.$route.params['id'];
      this.getProject();
      this.browserRedirect();
    },
    methods: {
      //判断是PC端还是移动端
      browserRedirect() {
        if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          //跳转移动端页面
          this.isShowApp = true;
          return false;
        } else {
          //跳转pc端页面
          this.isShowApp = false;
        }
      },
      goDownPage() {
        this.$router.push({name: 'appDown', query:{type: 'project', id: this.projectId}});
      },
      getProject() {
        this.isLoading  = true;
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.projectObj = res;
          this.isLoading  = false;
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.projectObj.name
          });

          if (this.projectObj.userProject && this.projectObj.userProject.signedUp) {
            this.canLearn = true;
          } else {
            this.canLearn = false;
          }

        }, (error) => {
          this.$router.push('/404');
        })
      },


    }
  }
</script>

<style>

</style>
